import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    successColor: {
        color: "#696969",
    },
    errorColor: {
        color: "#F44336"
    },
};

class Printing extends Component {

    constructor(props){
        super(props);

        this.state = {
            printingDimensionValue:null,
            printingAlbumText:null,
            printingNumber:1,
        }
    }

    printingDimension(event, index, value) {
        this.setState({
            printingDimensionValue: value,
            printingAlbumText:event.target.innerText,
        });

    }

    tualAlbumNumber(e){
        this.setState({tualAlbumNumber: e.target.value});
    }

    tualSubmit(e){
        this.props.onChange1(this.state.printingDimensionValue, this.state.printingAlbumText, this.props.number,this.state.printingNumber);
    }

    render(){
        return(
            <div className="full-width">
                <div className="form-group">
                    <SelectField
                        floatingLabelText="Baskı Ebatları"
                        floatingLabelStyle={styles.successColor}
                        value={this.state.printingDimensionValue}
                        onChange={this.printingDimension.bind(this)}
                    >
                        <MenuItem value={1} primaryText="10x15"/>
                        <MenuItem value={2} primaryText="15x21"/>
                        <MenuItem value={3} primaryText="24x30"/>
                        <MenuItem value={4} primaryText="30x40"/>
                        <MenuItem value={5} primaryText="30x50"/>
                        <MenuItem value={6} primaryText="30x70"/>
                        <MenuItem value={7} primaryText="30x80"/>
                        <MenuItem value={8} primaryText="30x90"/>
                        <MenuItem value={9} primaryText="50x70"/>
                        <MenuItem value={10} primaryText="75x100"/>
                    </SelectField>
                </div>

                <div className="form-group">
                    <TextField
                        type="number"
                        hintText="Baskı Sayısı"
                        floatingLabelStyle={styles.successColor}
                        floatingLabelText="Baskı Sayısı"
                        onChange={(e) => (e.target.value <= 127) ? this.setState({printingNumber: e.target.value}) : -1}
                        defaultValue={this.state.printingNumber}
                        value={this.state.printingNumber}
                    />
                </div>

                <div className="buttonDiv">
                    <RaisedButton
                        label="Ekle"
                        type="button"
                        onClick={this.tualSubmit.bind(this)}
                        disabled={(this.state.printingDimensionValue === null) ? "disabled":""}
                        icon={<i className="material-icons">add</i>}
                        primary={true} />
                </div>

            </div>
        );
    }

}


export default Printing;


// WEBPACK FOOTER //
// ./src/components/small/printing.js